import React, { useEffect } from "react";
import {
  PopupOverlay,
  PopupContainer,
  PopupTitle,
  ChecklistItem,
  CheckIcon,
  CrossIcon,
} from "../../styles/onboardingChecklist";
import { DocumentStatus } from "../../styles/profile";
import { FlexContainer } from "../../styles/PersonalInfoStep";
import { useNavigate } from "react-router-dom";
import { GET, POST } from "../../services/HTTPServices";
import { setItem } from "../../utils/cache/LocalStorage";
import { alertMessage } from "../../services/alertService";
import { ALERT_TITLES, ROUTES } from "../../constants";
import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../styles/loading";

interface ChecklistData {
  id: string;
  serviceProviderId: number;
  personalInfo: number;
  businessInfo: number;
  kyb: number;
  fileUpload: number;
  agreement: number;
}

interface OnboardingChecklistProps {
  onClose: () => void;
  goKYB: Function;
  data: ChecklistData;
}

const OnboardingChecklist: React.FC<OnboardingChecklistProps> = ({
  data,
  onClose,
  goKYB,
}) => {
  const navigate = useNavigate();
  const [auth, setAuth] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);

  // Transform the data into checklist items
  const checklistItems = [
    { id: 0, name: "Personal Information", completed: data.personalInfo === 2 },
    { id: 1, name: "Business Information", completed: data.businessInfo === 2 },
    { id: 2, name: "KYB Verification", completed: data.kyb === 2 },
    { id: 3, name: "Files Upload", completed: data.fileUpload === 2 },
    { id: 4, name: "Sign Contract", completed: data.agreement === 2 },
  ];

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      setAuth(authUser);
    }
  }, []);



  const returnStatus = (index: number) => {
    let val =
      index === 0
        ? data.personalInfo
        : index === 1
        ? data.businessInfo
        : index === 2
        ? data.kyb
        : index === 3
        ? data.fileUpload
        : data.agreement;
    switch (val) {
      case 0: {
        return "pending";
      }
      case 1: {
        return "in_progress";
      }
      case 2: {
        return "completed";
      }
      case 3: {
        return "rejected";
      }

      default: {
        return "pending";
      }
    }
  };

  const returnStatusLabel = (index: number) => {
    let val =
      index === 0
        ? data.personalInfo
        : index === 1
        ? data.businessInfo
        : index === 2
        ? data.kyb
        : index === 3
        ? data.fileUpload
        : data.agreement;
    switch (val) {
      case 0: {
        return "Pending";
      }
      case 1: {
        return "In Progress";
      }
      case 2: {
        return "Completed";
      }
      case 3: {
        return "Rejected";
      }

      default: {
        return "Pending";
      }
    }
  };

  const clickedCheckItem = (item: any) => {
    if(item.completed)return;
    if (item.id === 4) navigate(ROUTES.SIGNAGREE);
    else if (item.id === 2) {
      gotoKYB();
    } else navigate("/profile");
  };

  const gotoKYB = async () => {
    setLoading(true);

    let temp = {
      businessType: "individual",
      email: auth.email,
      firstName: auth.firstName || "Testing",
      kybVerificationRequestAddress: {
        city: "Singapore",
        country: "Singapore",
        line1:
          "111 " +
          "Jurong , Block " +
          "Blk-115, Singapore " +
          "600111",
        line2: "",
        postalCode: "600111",
      },
      kybVerificationRequestDateOfBirth: {
        day: 13,
        month: 7,
        year: 1995,
      },
      lastName: auth.lastName || "Merchant",
      phone: auth.phone,
      serviceProviderId: auth.id + "",
      returnUrl: "http://localhost:3000/dashboard-kyb",
      refreshUrl: "http://localhost:3000/dashboard-kyb",
    };

    let url = "serviceprovider/RequestKYBVerification";

    let res: any = await POST(url, temp, "provider", true);

    if (res && res.status === 200) {
      setItem("accountId", res.data.accountId);
      getCheckList(auth.id,res.data.onboardingUrl)
    } else {
      setLoading(false);
      if (res.status && res.status === 401) {
        navigate("/unauthorized-page");
      } else {
        alertMessage(ALERT_TITLES.ERROR, res.message);
      }
    }
  };

  const getCheckList = async (id: any,KYBURL : string) => {
        const res: any = await GET(
          "onboardingcheck/GetOnboardingCheckBySpId?spId=" + id,
          "provider"
        );
        if (res && res.data) {
          postChecklist(res.data[0],KYBURL)
        }
      };

    const postChecklist = async (checklist : any,KYBURL : string) => {
        setLoading(true);
        let url = "onboardingcheck/UpdateOnboardingCheck";
    
        let temp = {
          serviceProviderId: checklist.serviceProviderId,
          personalInfo: checklist.personalInfo,
          businessInfo: checklist.businessInfo,
          kyb: 2,
          fileUpload: checklist.fileUpload,
          agreement: checklist.agreement,
        };
    
        let res: any = await POST(url, temp, "provider");
    
        if (res && res.status === 200) {
          
        goKYB(KYBURL);

        setLoading(false);
        } else {
          setLoading(false);
          if (res.status && res.status === 401) navigate("/unauthorized-page");
          else {
            alertMessage(ALERT_TITLES.ERROR, res.message);
          }
        }
      };

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}

      <PopupOverlay onClick={onClose}>
        <PopupContainer onClick={(e) => e.stopPropagation()}>
          <PopupTitle>Onboarding Checklist</PopupTitle>
          {checklistItems.map((item, index) => (
            <ChecklistItem key={index} onClick={() => clickedCheckItem(item)}>
              <FlexContainer>
                {item.completed ? <CheckIcon /> : <CrossIcon />}
                <span>{item.name}</span>
              </FlexContainer>
              <DocumentStatus status={returnStatus(index)}>
                {returnStatusLabel(index)}
              </DocumentStatus>
            </ChecklistItem>
          ))}
        </PopupContainer>
      </PopupOverlay>
    </>
  );
};

export default OnboardingChecklist;
